import { createContext, useContext } from 'react';

interface AlertContextType {
	alertId: string;
	closeAlert: () => void;
}

const AlertContext = createContext<AlertContextType | null>(null);

export const useAlertContext = (): AlertContextType | null => {
	return useContext(AlertContext) ?? null;
};
